import { render, staticRenderFns } from "./heatSelector.vue?vue&type=template&id=a4364d0e&scoped=true&"
import script from "./heatSelector.vue?vue&type=script&lang=js&"
export * from "./heatSelector.vue?vue&type=script&lang=js&"
import style0 from "./heatSelector.vue?vue&type=style&index=0&id=a4364d0e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4364d0e",
  null
  
)

export default component.exports